module.exports = [{
      plugin: require('/codebuild/output/src411543220/src/oas-atlas-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
